// Chart configuration
export const CHART_CONFIG = {
  margin: { top: 56, bottom: 68, left: 60, right: 32 },
  height: 312,
  desiredTickCount: 6, // Desired number of ticks on the Y-axis
  YAxisLabelOffsetX: 24,
  YAxisLabelOffsetY: 12,
  badgePadding: 7,
  containerBorderRadius: 6,
  xAxisStrokeWidth: 1,
  yAxisLabel: {
    xAdjust: -9,
    y: 24,
    width: 30,
    height: 0,
  },
  marker: {
    verticalLineStrokeWidth: 3,
    pointRadius: 4,
    pointStrokeWidth: 3,
  },
} as const;
